/* premium-crossout.js - draw-on enhancement for the crossout line (premium-crossout.liquid).
 * Progressive enhancement + FLASH-SAFE: the static struck state is the default (CSS). This only
 * animates instances that are BELOW the fold at load - it arms them off-screen (hidden strike/word)
 * and draws them on when scrolled into view, so there is never a flash of the static state. Instances
 * already in view at load, or under reduced motion, or with no JS, stay static struck (no animation).
 */
(function () {
  var reduce = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  if (reduce || !('IntersectionObserver' in window)) return; // static struck, no anim

  function init() {
    var els = document.querySelectorAll('.thrux-premium .xo[data-xo]');
    if (!els.length) return;
    var below = [];
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top >= window.innerHeight) below.push(els[i]); // strictly below the fold at load
    }
    if (!below.length) return; // nothing safe to animate; leave all static struck
    document.documentElement.classList.add('thrux-xo-anim');
    // arm off-screen instances in the same frame the class lands (they're not visible, so no flash)
    for (var j = 0; j < below.length; j++) below[j].setAttribute('data-xo-armed', '');
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.setAttribute('data-xo-drawn', ''); obs.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    for (var k = 0; k < below.length; k++) io.observe(below[k]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
